import { gql } from "@apollo/client";

export const Get_TimeZones = gql`
  query {
    timeZones {
      key
      value
    }
  }
`;
